import {Injectable} from '@angular/core';
import {RouterStateSnapshot, ActivatedRouteSnapshot, Router, CanActivate} from '@angular/router';
import {LoadUserAction} from "../ngrx/actions/user.action";
import {Store} from "@ngrx/store";
import * as wjcCore from "@mescius/wijmo";

@Injectable()
export class AdminGuard implements CanActivate {
    user: any;

    constructor(private router: Router, private store: Store<any>) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("activePromotionFeature").subscribe((digitalAuction: any) => {
            this.user = digitalAuction.user.user;
        });
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot) {
        if (wjcCore.isArray(this.user.roles)) {
            for (let role of this.user.roles) {
                if (role.name == "管理者") {
                    return true;
                }
            }
        }
        this.router.navigateByUrl('user');
        return false;
    }
}
